app.components.video = {
    onReady: function () {
        if ($('.video').length) {
            return true;
        }
    },
    addListener: async function () {
        const videoSources = ['iframe[src*="youtube"]', 'iframe[src*="vimeo"]', 'video'];

        document.querySelectorAll(videoSources.join(",")).forEach((video) => {
            // Fitvids
            video.style.width = "auto";
            video.style.height = "100%";
            video.style.maxWidth = "100%";
            video.style.aspectRatio = `${video.getAttribute(
                "width"
            )} / ${video.getAttribute("height")}`;
            video.removeAttribute("height");
            video.removeAttribute("width");
        });

    }
};
